<form #form fsForm [submit]="save" *fsSkeletonForm="environmentCreate">
  <mat-card-content>
    <div class="fs-column.align-center.justify-center">
      <h1>Name Your Organization</h1>
      <p>This could be the name of your school or organization</p>
      <mat-form-field class="full-width">
        <mat-label>Organization name</mat-label>
        <input matInput
          [(ngModel)]="environmentCreate.workspaceName"
          fsFormRequired
          required
          name="workspace_name"
          cdkTrapFocus
          [cdkTrapFocusAutoCapture]="true">
        <mat-hint>This can be changed later</mat-hint>
      </mat-form-field>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <button type="submit" mat-flat-button color="primary" class="full-width">Continue</button>
  </mat-card-actions>
</form>
